<template>
  <v-container v-if="div == 1 " fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnAddOne', 
                      'btnSelectMore'   
                    ]"
                    @btnAddOne="btnMakeOne()"
                    @btnSelectMore="btnMakeMore()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">                          
                          <i-label :label="'Add new Bill No : '" class="pl-2"/>
                          <v-col cols="2">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              maxLength="30"
                              v-model="newBillNo"                            
                            />
                          </v-col>
                          <i-label :label="'R Ton : '" class="pl-2"/>
                          <v-col cols="1">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              maxLength="30"
                              v-model="rton"                            
                            />
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                  
                  <DxDataGrid id="departmentInformation" 
                    class="listBox" 
                    :ref="hycot102Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"  
                    :repaint-changes-only="true"                                      
                  >                                        
                    <DxColumn caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" cell-template="rowNo"/>
                        <template #rowNo="{ data }">
                            <div>{{ data.component.pageIndex() * data.component.pageSize() + data.rowIndex + 1 }}</div>
                        </template>
                    
                    <DxColumn data-field="blNo" caption="Bill of Lading" width="50%" data-type="string" alignment="left"  :allow-editing="false" />
                    <DxColumn data-field="rton" caption="R Ton" width="20%" data-type="number" format="#,###.###" alignment="right"  :allow-editing="false" />
                    <DxColumn  width="40%" data-type="string" alignment="left" cell-template="delBtn" :allow-editing="false" />                    

                     <template #delBtn="{ data: cellInfo }">
                            <v-btn small elevation="0" color="transparent" class="px-1 py-0 delBtn" @click="btnDelete(cellInfo)" >
                                <v-icon small class="mt-n1">
                                    mdi-trash-can-outline
                                </v-icon>
                                Delete
                            </v-btn>                          
                        </template>                                        
                                      
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
     <hycot102Popup :showHycot102Pop.sync = "showHycot102PopUp" :invNo = "invNo"  @saveBl="doSearchMain()"/>
  </v-container>
   <v-container v-else fluid align-start ma-0 pa-2 class="container-height">
      <v-row no-gutters fill-height>
        <v-col cols="12">
          <i-card-vertical :headerTitle="menuTitle" :useBtnList="['btnSave']" @btnSave="btnSave()" >
            <template v-slot:body>
              <v-layout column overflow-auto>               
                <v-row no-gutters class="form-layout">
                 <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="2" align="center" class="pt-1 formHeader">
                      <span>Transport Type</span>
                    </v-col>
                    <v-col cols="3" >                  
                        <v-select
                          v-model="transType"
                          :items="transTypeList"
                          item-value="code"
                          item-text="code"
                          return-object
                          single-line
                          outlined
                          dense
                          height="34" 
                           @change="init()"/>                                       
                    </v-col>
                    <v-col cols="2" align="center" class="pt-1 formHeader">
                      <span>Fee Description</span>
                    </v-col>
                    <v-col cols="5">                     
                        <v-select
                          v-model="feeDesc"
                          :items="feeDescList"
                          item-value="feeCd"
                          item-text="feeCd"
                          return-object
                          single-line
                          outlined
                          dense
                          height="34" />                                            
                    </v-col>
                  </v-row>
                  <v-row v-if="makerDiv == 'A'" no-gutters>
                      <v-col cols="2" align="center" class="pt-1 formHeader">
                        <span>Amount (VND)</span>
                      </v-col>
                      <v-col cols="3" >                  
                            <v-text-field
                              v-model="amtVnd"                             
                              type="number"                                
                              dense 
                              outlined                                                            
                              height="32"                              
                            />                              
                      </v-col>
                      <v-col cols="2" align="center" class="pt-1 formHeader">
                        <span>VAT (VND)</span>
                      </v-col>
                      <v-col cols="5">                     
                            <v-text-field
                                v-model="vatVnd"                                 
                                type="number"  
                                dense 
                                outlined                                                                 
                                height="32"
                              />                                      
                      </v-col>
                    </v-row>
                    <v-row v-else no-gutters>
                        <v-col cols="2" align="center" class="pt-1 formHeader">
                          <span>Amount (USD)</span>
                        </v-col>
                        <v-col cols="3" >                  
                              <v-text-field
                                v-model="amtUsd"                               
                                type="number"                                
                                dense 
                                outlined                                                            
                                height="32"
                              />                              
                        </v-col>                       
                      </v-row>
                </v-col>
              </v-row>

                <v-row no-gutters>
                  <v-col cols="12" class="pa-0">                  
                    <DxDataGrid id="departmentInformation" 
                      class="listBox" 
                      :ref="hycot102AmtRef"
                      :data-source="gridMainList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :selection="{ mode: 'none' }"  
                      :repaint-changes-only="true"     
                      @cellPrepared="cellPrepared"                                 
                    >                                        
                      <DxColumn caption="No" width="5%" data-type="string" alignment="center" :allow-editing="false" cell-template="rowNo"/>
                          <template #rowNo="{ data }">
                              <div>{{ data.component.pageIndex() * data.component.pageSize() + data.rowIndex + 1 }}</div>
                          </template>
                    
                      <DxColumn data-field="feeDesc" caption="Fee Description" width="25%" data-type="string" alignment="left"  :allow-editing="false" />
                      <DxColumn data-field="amtUsd" caption="Amout (USD)" width="15%" data-type="number" format="#,###.##" alignment="right"  :allow-editing="false" />
                      <DxColumn data-field="amtVnd" caption="Amout (VND)" width="15%" data-type="number" format="#,###" alignment="right"  :allow-editing="false" />
                      <DxColumn data-field="vatVnd" caption="VAT (VND)" width="15%" data-type="number" format="#,###" alignment="right"  :allow-editing="false" />
                      <DxColumn data-field="subTotal" caption="Total (VND)" width="15%" data-type="number" format="#,###" alignment="right"  :allow-editing="false" />
                      <DxColumn  width="10%" data-type="string" alignment="center" cell-template="delBtn" :allow-editing="false" />                    
                       <template #delBtn="{ data: cellInfo }">
                              <v-btn small elevation="0" color="transparent" class="px-1 py-0 delBtn" @click="btnDeleteAmt(cellInfo)" >
                                  <v-icon small class="mt-n1">
                                      mdi-trash-can-outline
                                  </v-icon>
                                  Delete
                              </v-btn>                          
                          </template>                                        
                                      
                      <DxPaging :enabled="true" :page-size="20" />
                       <DxSummary>
                          <DxTotalItem
                            column="feeDesc"
                            summary-type="sum"
                            display-format="Page Total"
                             alignment="center"
                          />
                          <DxTotalItem
                            column="amtUsd"
                            summary-type="sum"
                            alignment="right"
                            :customize-text="price2p"
                          />
                          <DxTotalItem
                            column="amtVnd"
                            summary-type="sum"                            
                            alignment="right"
                             :customize-text="price"
                          />
                          <DxTotalItem
                            column="vatVnd"
                            summary-type="sum"
                            alignment="right"
                             :customize-text="price"
                          />
                          <DxTotalItem
                            column="subTotal"
                            summary-type="sum"
                            alignment="right"
                             :customize-text="price"
                          />
                          
                        </DxSummary>
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-layout>
            </template>
          </i-card-vertical>
        </v-col>
      </v-row>     
    </v-container>
</template>

<script>

import { DxDataGrid, DxEditing, DxColumn, DxButton, DxExport, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import hycot102Popup from '@/views/hycot/1/popup/hycot102Popup'
import { getNumComma } from '@/utils/common.js'
import notify from 'devextreme/ui/notify'
import { getInvDetailBill, deleteNewBill, makeNewBill, getInvDetailAmt, getFeeList, deleteInvAmt, newInvAmt } from '@/api/view/hycot/1/hycot102.js'

export default {
  name: 'hycot102',
  mixins: [baseview, BaseDataGrid],
  components: {
		DxTotalItem,
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxButton,
    DxExport,
    hycot102Popup,
    DxSummary,
    DxTotalItem
  },
  data() {
    return {
      div: 1,
      invNo: '',
      menuTitle: '',      

      hycot102Ref: 'hycot102Ref',
      hycot102AmtRef: 'hycot102AmtRef',
      gridMainList: [{a: '2022/12/05', id: 1 , test: "N"}],

      gridMainList2:[],

      newBillNo: '',     
      showReceive: true,
      showHycot102PopUp: false,

      transType: {code: 'SEA'},
      transTypeList: [
        { code: 'SEA' },
        { code: 'AIR' },
        { code: 'ETC' }
      ],

      feeDesc: { feeCd: 'Select Code' },
      feeDescList: [
        { feeCd: 'Select Code' }
      ],
      makerDiv : this.$store.state.user.makerCd.substr(0,1) == '9' ? 'F' : 'A',
      makerCd  : this.$store.state.user.makerCd,
      amtVnd: 0,
      vatVnd: 0,
      amtUsd: 0,
      rton : 0,

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.hycot102Ref)
    },
     gridMainInstance2() {
      return this.GetDataGrid(this.hycot102AmtRef)
    }
  },
  created() {
      this.div = this.$route.params.div
      this.init()
    if (this.$route.params.invNo) {
      this.invNo = this.$route.params.invNo

      if (this.$route.params.div == 1) {
        this.menuTitle = "1.2 View Bill No Detail of Invoice : " + this.invNo
        this.doSearchMain()
      } else {
        this.menuTitle = "1.2 View Amount Detail of Invoice : " + this.invNo
        this.init()
        this.doSearchAmount()
      }

    }
  },
 
  methods: {  
    price2p(data) {
      return data.value.toFixed(2);
    }, 
     price(data) {
      return getNumComma(data.value)
    },
    getNumComma(val) {
      return getNumComma(val)
    },
    contructor() {
      this.transType = { code: 'SEA' }
      this.transTypeList = [
        { code: 'SEA' },
        { code: 'AIR' },
        { code: 'ETC' }
      ]

      this.feeDesc = { feeCd: 'Select Code' }
      this.feeDescList = [
        { feeCd: 'Select Code' }
      ]

      this.amtVnd = 0
      this.vatVnd = 0
      this.amtUsd = 0
    },
    init() {      
      let param = {
        shipDiv : this.transType.code,
        makerCd : !this.makerCd ? 'SEA': this.makerCd
      }
      console.log('Fee Desc : ', param);
      this.feeDescList = []
      getFeeList(param).then(res => {
        this.feeDescList.push('Select Code')
        res.list.forEach(e => {
          this.feeDescList.push({ feeCd : e.feeCd })
        });
      })
      
    },   
    async doSearchMain(){
      this.openLoading('searching')
      let params = {          
          invNo: !this.invNo ? '' : this.invNo       
      }
      console.log(params)
      await getInvDetailBill(params).then(res => {
        res.list.forEach(e => {
          e.id = e.rnum
        });
        this.gridMainList = res.list
      }).finally(() => {
        this.endLoading()
      })

    },
     async doSearchAmount() {
      this.openLoading('searching')
      let params = {
        invNo: !this.invNo ? '' : this.invNo
      }
      console.log(params)
      await getInvDetailAmt(params).then(res => {
        res.list.forEach(e => {
          e.id = e.rnum
        });
        this.gridMainList2 = res.list
      }).finally(() => {
        this.endLoading()
      })

    },
    cellPrepared(e){
      if(e.rowType === 'totalFooter'){
          e.cellElement.style.borderRight = '1px solid gray'
        if (e.column.caption == 'No' && e.columnIndex == 0) {
            e.cellElement.style.display = 'none'
        } else if (e.column.caption == 'Fee Description' && e.columnIndex == 1) {
             e.cellElement.setAttribute('colspan', 2)              
        } else if( e.columnIndex == '6'){
          e.cellElement.style.borderRight = '0'
        }
      }
    },   

    btnMakeOne() {

       if (!this.invNo) {
        this.vToastify(this.$t("Invoice No not found! Can not save!"), 'warn')
        return
      }

       if (!this.newBillNo) {
        this.vToastify(this.$t("Please input New Bill No!"), 'warn')
        return
      }

      if (!this.rton) {
        this.vToastify(this.$t("Please input R ton for New Bill No!"), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to make New Bill No [' + this.newBillNo + ']?'),
        'info',
        current => {

          this.openLoading('searching')
          let param = []
           param.push({
            makerCd: this.$store.state.user.makerCd,
            invNo: this.invNo,
            newBl: this.newBillNo,
            rton : this.rton
          })
          makeNewBill(param)
            .then(res => {
              console.log(res)
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              this.newBillNo = ''
              this.doSearchMain()
              this.endLoading()
            })
        },
        null,
        false
      )
      
    },

    btnMakeMore() {

       if (!this.invNo) {
        this.vToastify(this.$t("Invoice No not found! Can not save!"), 'warn')
        return
      }

      this.showHycot102PopUp = true
      
    },

    btnSave() {

       if (!this.invNo) {
        this.vToastify(this.$t("Invoice No not found! Can not save!"), 'warn')
        return
      }

      console.log('amtVnd', this.amtVnd)
      console.log('vatVnd', this.vatVnd)

      if (this.feeDesc.feeCd.substring(0, 3) == 'Sel') {
        this.vToastify(this.$t("Please select Fee Description!"), 'warn')
        return
      }      

       this.vToastifyPrompt(
        this.$t('Do you want to save new Amount?'),
        'info',
        current => {

          this.openLoading('searching')
          let param = {}

          if (this.makerDiv == 'A') {
            param = {
              invNo: this.invNo,
              feeCd: this.feeDesc.feeCd,
              feeUsd: 0,
              feeVnd: this.amtVnd,
              vatVnd: this.vatVnd,
              makerCd: this.$store.state.user.makerCd
            }
          } else {
            param = {
              invNo: this.invNo,
              feeCd: this.feeDesc.feeCd,
              feeUsd: this.amtUsd,
              feeVnd: 0,
              vatVnd: 0,
              makerCd: this.$store.state.user.makerCd

            }
          }
          console.log(param)
          newInvAmt(param)
            .then(res => {
               if (res.body === 'OK') {
                    notify(this.$t('Invoice amount is saved.'), 'success', 3000)
                                              
                } else {
                    this.vToastify(this.$t("An error has occured while saving data...."), 'warn')
                }
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              this.contructor()
              this.init()              
              this.doSearchAmount()
              this.endLoading()              
            })
        },
        null,
        false
      )

    },
                   
    btnDelete(e) {
      let blNo = e.data.blNo     

       this.vToastifyPrompt(
        this.$t('Do you want to delete B/L : '+ blNo +' ?'),
        'info',
         current => {   

          this.openLoading('searching')
          
          const param = {
            newBl: blNo,
            invNo: this.invNo
           }
          
          deleteNewBill(param)
            .then(res => {
                console.log(res)
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              this.doSearchMain()
              this.endLoading()
            })
        },
        null,
        false
      )

    },

    btnDeleteAmt(e) {     

      let feeCd = e.data.feeDesc.substr(0,3)      

      this.vToastifyPrompt(
        this.$t('Do you want to delete fee code : ' + feeCd + ' ?'),
        'info',
        current => {

          this.openLoading('searching')

          const param = {            
            invNo: this.invNo,
            feeCd: feeCd
          }

          deleteInvAmt(param)
            .then(res => {
               if (res.body === 'OK') {
                    notify(this.$t('Invoice Amount is deleted.'), 'success', 3000)
                                              
                } else {
                    this.vToastify(this.$t("An error has occured while saving data...."), 'warn')
                }
            }).catch(error => {
              this.vToastify(error, 'warn')
            }).finally(() => {
              this.doSearchAmount()
              this.endLoading()
            })
        },
        null,
        false
      )

    }
  }
}
</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }

  .form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}

  .formHeader {
   background-color: rgb(223, 227, 213);
   font-weight: bold;
   border: 1px solid gray;
   color: black;
   font-size: 9pt;
 }

  .vat {
    color: blue;
  }
  .receiptBtn {
    font-weight: bold;
    color: #4980BC;
  }
  .receiptBtn:hover {
    color: blue;
  }

  .addBtn {
    font-weight: bold;
    color: #FF3333;
  }
  .addBtn:hover {
    color: #CC0000;
  }

  .delBtn {
    font-weight: bold;
    color: #FF66B2;
  }
  .delBtn:hover {
    color: #CC0066;
  }
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>